module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('transition', {
    attrs: {
      "name": "push",
      "mode": "out-in"
    }
  }, [(!_vm.underAge) ? _c('div', {
    key: "buttons",
    staticClass: "modal-content--btn"
  }, [_c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": '/' + _vm.destination
    }
  }, [_c('span', [_vm._v("Ja, ich bin mindestens 16 Jahre alt.")])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.underAge = !_vm.underAge
      }
    }
  }, [_c('span', [_vm._v("Nein, leider noch nicht.")])])], 1) : _vm._e(), _vm._v(" "), (_vm.underAge) ? _c('div', {
    key: "deny",
    staticClass: "modal-deny"
  }, [_c('p', [_vm._v("Der Internetauftritt steht leider nur Personen zu Verfügung,\n                            die mindestens 16 Jahre alt sind.")])]) : _vm._e()])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "modal-header"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/logo.svg",
      "alt": "Privatbrauerei Zissel"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Ihre Privatbrauerei Zissel setzt sich im Rahmen der gesetzlichen\n            Bestimmungen für den verantwortungsbewussten Umgang mit alkoholischen\n            Getränken ein. Auf den folgenden Seiten finden Sie Information\n            über alkoholische Getränke.")]), _vm._v(" "), _c('p', [_vm._v("Wir bitten Sie daher zu bestätigen, dass Sie über 16 Jahre alt sind!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6043c977!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/partials/age-confirmation.vue
// module id = 31
// module chunks = 0